import React from 'react';

import { Container } from './styles';

const Footer: React.FC= ({ children, ...props }) => {
  return (
    <Container {...props}>
      <>{children}</>
    </Container>
  );
};

export default Footer;
